import * as React from "react"
import Arrow from "../components/arrow"
import MenuLinks from "../components/menuLinks"  
 
class Menu extends React.Component {
  render() {
    return (
      <div className='overlay--menu' style={{ background: this.props.background }}>
        <div className="menu--header">
          <div className="inner flex align-center"> 
            <div className="return--container">
              <div className="close--icon m-mt20">
                <Arrow />
              </div>
            </div>
            <div className="page-title mla mra h4 m-hide">
              Menu
            </div> 
            <div className="booking--container m-hide"> 
              <a className="strong underline-link internal--link" href="/contact">Make a booking</a> 
            </div>
          </div>
        </div>
        <div className="menu--container">
          <MenuLinks />
        </div> 
      </div>
    )
  } 
} 

export default Menu

